import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

/**
 * This callback is displayed as a global member.
 * @callback eventCallback
 * @param {object} event Event callback
 * @param {HTMLElement} target Event target
 */

/**
 * Properties for delegating events
 * @typedef {Object} DelegateParams
 * @property {HTMLElement} element - Element to attach the event listener to
 * @property {string} event Event to listen for
 * @property {string} selector Selector to listen for events on
 * @property {eventCallback} callback Event Callback Function
 */
;
/**
 * Attaches an event listener to an ancestor node to listen for events on the
 * children nodes.
 *
 * @param {DelegateParams} params Information about the event listener
 * @returns {void} A function to remove the attached event listener
 */

export var delegate = function delegate(params) {
  var element = params.element,
      selector = params.selector,
      event = params.event,
      callback = params.callback;

  var internalCallback = function internalCallback(event) {
    if (!event.target || !(event.target instanceof HTMLElement || event.target instanceof SVGElement) || _typeof(event.target['matches']) === (typeof undefined === "undefined" ? "undefined" : _typeof(undefined))) return;
    var target = event.target.matches(selector) ? event.target : event.target.closest(selector);
    if (!target) return;
    callback(event, target);
  };

  var elem = typeof element === 'string' ? document.querySelector(element) : element;
  if (!elem) return null;
  elem.addEventListener(event, internalCallback);
  return function () {
    return elem && elem.removeEventListener(event, internalCallback);
  };
};
/**
 *
 * @param {Event} e - Event to find target from
 * @param {string} selector - Selector string to find target with
 */

export var findTarget = function findTarget(e, selector) {
  if (!e.target || !(e.target instanceof HTMLElement || e.target instanceof SVGElement) || _typeof(e.target['matches']) === (typeof undefined === "undefined" ? "undefined" : _typeof(undefined))) return;
  var target = e.target.matches(selector) ? e.target : e.target.closest(selector);
  return target;
};